<template>
  <BasicLayout>
    <div class="cancelled">
      <div class="cancelled__content">
        <div class="status-info__wrap">
          <div class="status-info">
            <div>
              <h2>Bestellung nicht vorhanden</h2>
              <p class="status-info__text">
                Bitte wenden Sie sich an unseren Support
              </p>
            </div>
            <p class="sub-title-text no-space">
            Sollten Sie technische Probleme mit der Finanzierungsanfrage haben,
            oder Unterstützung bei der Eingabe benötigen, so melden Sie sich
            gerne telefonisch bei uns unter: <a href="tel:02119462550">Tel. 0211 94 62 550</a> (Montag bis Freitag zwischen 08:30 und 17:00)
          </p>
          </div>
        </div>
      </div>
      <Contacts />
    </div>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../components/layout/BasicLayout';
import Contacts from '../components/Contacts';

export default {
  components: {
    BasicLayout,
    Contacts,
  },
};
</script>

<style lang="scss" scoped>

.sub-title-text {
  padding-top: 20px;
  text-align: center;
}

p {
  line-height: 30px;
}

a {
  color: #e64e45;
}

.cancelled {
  &__new-search-wrap {
    margin-top: 25px;
    img {
      width: 100%;
    }
  }
  &__new-search {
    padding: 26px 20px 30px;
    background-color: $green;
    color: $white;
    h4 {
      margin-bottom: 5px;
      font-size: 20px;
      font-weight: 700;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
    a {
      display: block;
      padding: 12px;
      margin-top: 20px;
      font-size: 1rem;
      font-weight: 700;
      text-align: center;
      background-color: $white;
      color: $darkgray;
    }
  }
}

.status-info {
  h2 {
    padding-bottom: 0.3125rem;
    font-size: 1.125rem;
    line-height: 1.25rem;
  }
  &__wrap {
    padding: 1.6875rem 1.25rem 1.25rem;
  }
  &__text {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  &__status {
    padding: 1.25rem;
    margin-top: 1.25rem;
    border: 0.0625rem solid $border-gray;
    h4 {
      padding-bottom: 0.3125rem;
      font-size: 1rem;
      font-weight: 700;
    }
    p {
      font-size: 0.875rem;
      color: $green;
    }
  }
  @include breakpoint(tablet) {
    padding: 3.75rem 1.25rem 2.8125rem;
    background-color: $white;
    &__wrap {
      padding: 0;
      background-color: #e5e5e5;
    }
    > div:first-child {
      max-width: 29rem;
      margin: 0 auto;
    }
    h2 {
      font-size: 1.625rem;
      line-height: normal;
      text-align: center;
    }
    &__text {
      font-size: 1rem;
      line-height: 1.5rem;
      text-align: center;
    }
    .status-info__status {
      display: flex;
      justify-content: center;
      margin-top: 1.25rem;
      h4 {
        padding-bottom: 0.3125rem;
        font-size: 1rem;
        font-weight: 700;
      }
      p {
        position: relative;
        padding-left: 3.125rem;
        font-size: 1rem;
        &:before {
          @include icon('\f00c', $green, 1.25rem);
          top: 0;
          left: 1.25rem;
          width: 1.25rem;
          height: 1.25rem;
        }
      }
    }
  }
  @include breakpoint(desktop) {
    h2 {
      font-size: 30px;
    }
    &__wrap {
      background-color: $white;
    }
    > div {
      max-width: 38.375rem;
      margin: 0 auto;
    }
    .status-info__status {
      max-width: 28.375rem;
    }
    &__text {
      padding-bottom: 20px;
    }
  }
}
@include breakpoint(tablet) {
  .cancelled {
    max-width: 710px;
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;
    &__new-search-wrap {
      display: flex;
      max-width: none;
      img {
        width: 40%;
        object-fit: cover;
      }
    }
    &__new-search {
      a {
        max-width: 240px;
        padding: 17px;
      }
    }
  }
}
@include breakpoint(desktop) {
  .cancelled {
    &__content {
      padding: 1.75rem 0 1.75rem;
    }
    &__new-search-wrap {
      max-width: none !important;
      padding: 0 31px;
      margin-top: 25px;
      img {
        width: 40%;
        object-fit: cover;
      }
    }
    &__form-wrap {
      position: relative;
    }
  }
}
</style>
